import React from "react";
import { Link } from "react-router-dom";
import MailchimpSignUpForm from "./MailchimpSignUpForm";

export default class Footer extends React.Component {
  render() {
    return (
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-sm-6">
              <div className="footer-hubspot">
                <p>
                  Join us for pet tips. Stuff you’ll really use, from real Vets.
                </p>
                <MailchimpSignUpForm />
              </div>
            </div>
            <div className="col-sm-3">
              <h5>
                <span>Company Info</span>
              </h5>
              <ul className="footer-links-list">
                <li>
                  <Link to="/about">About Vetchat</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms and Conditions</Link>
                </li>
                <li>
                  <Link to="/faq">FAQ</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
            {/* <div className="col-sm-2">
              <h5>
                <span>Partners</span>
              </h5>
              <ul className="footer-links-list">
                <li>
                  <a
                    href="https://www.bronrewards.com.au/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bron Rewards
                  </a>
                </li>
                <li>
                  <a
                    href="https://petsuppliesempire.com.au/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Pet Supplies Empire
                  </a>
                </li>
              </ul>
            </div> */}
            <div className="col-sm-3">
              <h5>
                <span>Connect with us</span>
              </h5>
              <ul className="footer-links-list social">
                <li>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/vetchat/"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/images/social/facebookicon.png"
                      className="attachment-full"
                      alt="vetchat on facebook"
                    />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://twitter.com/vetchatau"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/images/social/twittericon.png"
                      className="attachment-full"
                      alt="vetchat on twitter"
                    />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://instagram.com/vetchatau/"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/images/social/instagramicon.png"
                      className="attachment-full"
                      alt="vetchat on instagram"
                    />
                  </a>
                </li>
              </ul>
            </div>
            <hr className="col-sm-12" />
            <div className="col-sm-12 text-center copyright">
              &copy; {new Date().getFullYear()}{" "}
              <Link to="/">Vetchat Services Pty Ltd</Link>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
